import React, { Component } from 'react'
import { Button, Form, Table, Input, message, Row, Col } from 'antd'

import { getHealthOrdersPassengers } from '_src/api/api'

import { getCardTypeName,getOrderStatusName } from '_src/utils/tool'

import exportExcel from '_src/utils/exportExcel'
import moment from 'moment'

const { Search } = Input
class HealthOderPassengers extends Component {
  constructor (props) {
    super(props)
    this.firstLoad = true // 是否第一次加载
    this.loading = true
    this.upLoadFlage = true // 判断图片是否需要更新上传
    
    this.param = {
      passengerName: ''
    }
    this.status = ''
    this.pageNum = 0
    this.totalElements = 0
    this.state = {
      dataList: [],
      excelList: [],
    
    }
  }

  componentDidMount () {
    this.loadData()
  }
  loadData () {
    const { record: {shiftId} } = this.props
    // const { status, pageNum } = this.param 
    getHealthOrdersPassengers(shiftId)
      .then(res=>{
        this.loading = false
        const { data } = res
        const dataList = data.map((item, index)=>{
          return {index: (index+1), ...item, key: index, cardType: getCardTypeName(item.cardType) }
        })
        this.saveDataList = dataList
        this.setState(()=>({
          dataList: dataList,
          visible: false
        }))
        if (this.firstLoad) {
          this.firstLoad = false
          this.setState(()=>({
            excelList: dataList
          }))
        }
      })
  }
  columns = () => {
    return [
      {
        title: '排序',
        align: 'center',
        dataIndex: 'index',
        key: 'index',
      },
      {
        title: '订单号',
        align: 'center',
        dataIndex: 'orderSn',
        key: 'orderSn',
        
      },
      {
        title: '旅客信息',
        align: 'center',
        dataIndex: 'info',
        key: 'info',
      },
      // {
      //   title: <span>专题数量</span>,
      //   align: 'center',
      //   dataIndex: 'link',
      //   render: item => <a href={item} target='_blank'>{item}</a>
      // },
      {
        title: '联系电话',
        align: 'center',
        dataIndex: 'mobile',
        key: 'mobile',
        // render: type => <span>{getCardTypeName(type)}</span>
      },
     
      {
        title: '人数',
        align: 'center',
        dataIndex: 'count',
        key: 'count',
      },
      {
        title: '订单状态',
        align: 'center',
        dataIndex: 'sattus',
        key: 'sattus',
         render: type => <span>{getOrderStatusName(type)}</span>
      },
    ]
  }

 
  handleSearch = (key, v) => {
    this.param[key] = v
    const filterList = !!v?this.saveDataList.filter(item => {
      return item.info.indexOf(v) > -1
    }):this.saveDataList
    this.setState({
      dataList: filterList
    })
  }

  handleExcel = () => {
    const { excelList } = this.state
    let now = moment().format('YYYY-MM-DD')
    if (!!excelList.length) {
      exportExcel(this.columns(), excelList, `健康专线订单${now}`) 
    }
    else {
      message.error('没有需要导出的数据', 1.5)
    }
  }

  render () {
    const { dataList } = this.state
   
    return (
      <div className = "Special">
        <Form className = "goodlist_from">
          <div style = {{maxWidth: 900}}>
            <Row gutter = {24}>
              <Col span = {8}>
                <Form.Item label = "旅客姓名" >
                  <Search placeholder="请输入旅客姓名" onSearch={(v)=>{ this.handleSearch('passengerName', v) }} enterButton />
                </Form.Item>
              </Col>
              <Col span = {16}>
                <Form.Item style = {{float: 'right'}}>
                  <Button type = "primary" icon="download" onClick = { this.handleExcel }>导出</Button>
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
        <Table
          loading = {this.loading} 
          bordered
          columns = {this.columns()} 
          dataSource = {dataList}
        />
      </div>
    )
  }
}

export default HealthOderPassengers